import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';

/** @typedef {boolean} DeletePersonalDeviceWarning */
/** @typedef {Array<import('modules/users/types/users.enum').UserRoleEnum>} RolesWarning */
/**
 * @typedef {{
 *   dealerIds: string[],
 *   roles: import("modules/users/types/users.enum").UserRoleEnum[],
 *   status: import("modules/users/types/users.enum").UserStatusEnum,
 * }} ChangeStatusWarning
 */

/** @typedef {DeletePersonalDeviceWarning | ChangeStatusWarning | RolesWarning } WarningData */
/** @typedef {Map<import('modules/users/types/users.enum').WarningTypeEnum, WarningData>} WarningReducer */

/** @type {WarningReducer} */
export const initialState = {};

/**
 * @param {WarningReducer} payload
 * @returns {WarningReducer}
 */
const set = (_, { payload }) => {
  const { id: _id, ...warnings } = payload;
  return warnings;
};

/** @returns {WarningReducer} */
const reset = () => initialState;

export default createReducer(initialState, {
  [types.ADD_USER_WARNING]: set,
  [LOCATION_CHANGE]: reset,
  [types.CHECKS_MODAL_REJECT]: reset,
  [types.CHECKS_MODAL_APPROVE]: reset,
});
